import { createFileRoute, notFound } from '@tanstack/react-router'
import { PageRenderer } from '@/features/core/components/PageRenderer'
import type { Page } from '@/types'

export const Route = createFileRoute('/$slug')({
  component: DynamicPage,
  loader: async ({ params }) => {
    try {
      const response = await fetch('/data/pages.json')
      const pages: Page[] = await response.json()
      const page = pages.find((p) => p.slug === params.slug)

      if (!page) {
        throw notFound()
      }

      return { page }
    } catch {
      throw notFound()
    }
  },
  notFoundComponent: NotFound,
})

function DynamicPage() {
  const { page } = Route.useLoaderData()
  return <PageRenderer page={page} />
}

function NotFound() {
  return (
    <div className="container mx-auto px-4 py-16 text-center">
      <h1 className="text-4xl font-bold mb-4">Page Not Found</h1>
      <p className="text-gray-600">The page you're looking for doesn't exist.</p>
      <a href="/" className="text-blue-600 hover:underline mt-4 inline-block">
        Go Home
      </a>
    </div>
  )
}
